/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
///<reference path="../../docs-and-forms.models.ts"/>

module Meevo.Plugins.DocsAndForms {

    enum ViewTabsEnum {
        Preview = 0,
        Source = 1
    }

    interface IDocsAndFormsFormUploadedHtmlComponentScope extends ng.IScope {

    }

    class DocsAndFormsUploadedHtmlComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            'meevo.plugins.docsAndForms.DocsAndFormsRenderService',
            'meevo.components.modal.ModalService',
            'meevo.AppSettings',
            '$q',
            'meevo.plugins.docsAndForms.SystemTagsFactory',
        ];

        public formBuilderModel: IFormBuilderModel;
        public docsAndFormsModel: IDocsAndFormsModel;
        public disabled: boolean;
        public viewTab: ViewTabsEnum;
        public uploadHTMLInProgress = false;

        private initialHTML: string;
        private defaultIntakeTemplate: any;

        get viewTabsEnum() {
            return ViewTabsEnum;
        }

        get isDefaultTemplate(): boolean {
            return this.docsAndFormsModel.templateHTML === this.defaultIntakeTemplate;
        }

        constructor(
            private $scope: IDocsAndFormsFormUploadedHtmlComponentScope,
            private docsAndFormsRenderService: Meevo.Plugins.DocsAndForms.DocsAndFormsRenderService,
            private modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private _$q: ng.IQService,
            private _systemTagsFactory: SystemTagsFactory
        ) {
        }

        $onInit() {
            this.viewTab = ViewTabsEnum.Preview;
            this.initialHTML = this.docsAndFormsModel.templateHTML;
        }

        importDefault() {
            this.modalService.confirm('MESSAGE_CONFIRM_DEFAULT_TEMPLATE')
                .then((result) => {
                    if (result) {
                        this.docsAndFormsRenderService.generateHTMLDefaultIntakeTemplate(this.$scope)
                            .then((html: string) => {
                                if (this.docsAndFormsModel) {
                                    html = html.replace(/<style >/g, '<style>')
                                    this.docsAndFormsModel.templateHTML = html;
                                }
                            });
                    }
                });
        }

        checkHtml() {
            this.uploadHTMLInProgress = true;
            this.docsAndFormsModel.formCreationTypeEnum = DocsAndFormsCreationTypeEnum.CustomHtmlUpload;
        }

        iframeLoadedAndReady() {
            if (!this.uploadHTMLInProgress) return;

            const iframeElement: HTMLIFrameElement = window.frames['previewFrame'].frameElement;
            const modalWarningsMessages = [];

            const isBuilt = this.docsAndFormsModel.hasCustomField || this._systemTagsFactory.formHasSystemTags(this.docsAndFormsModel);
            if (!isBuilt) {
                modalWarningsMessages.push('WARNING_HTML_DOESNT_CONTAINS_SYS_TAGS');
            }
            
            if (this._systemTagsFactory.hasInvalidSystemTags(this.docsAndFormsModel)) {
                modalWarningsMessages.push('WARNING_HTML_INVALID_SYS_TAGS');
            }

            const externalLinks = this.docsAndFormsRenderService.getExternalLinks(iframeElement.contentDocument);
            const hasExternalLinks = externalLinks.length > 0;
            if (hasExternalLinks) {
                console.warn(`HTML contains external URLs`, externalLinks);
                modalWarningsMessages.push('WARNING_HTML_CONTAINS_EXTERNAL_LINKS');
            }

            modalWarningsMessages.reduce((deferred, message) => {
                return deferred.then(() => this.modalService.alert(message));
            }, this._$q.resolve()).then(() => {
                this.uploadHTMLInProgress = false;

                if (hasExternalLinks) {
                    this.docsAndFormsModel.templateHTML = this.initialHTML;
                } else {
                    this.initialHTML = this.docsAndFormsModel.templateHTML;
                }
            });
        }
    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsUploadedHtmlComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/uploaded-html/docs-and-forms-uploaded-html.component.html',
            controller: DocsAndFormsUploadedHtmlComponent,
            controllerAs: '$ctrl',
            bindings: {
                docsAndFormsModel: '=',
                formBuilderModel: '=',
                disabled: '=?ngDisabled',
                hasDefault: '=',
            }
        });

}
